"use client";
import { useContext } from "react";
import { NavigationContext, type FeatureHost } from "./navigation-context";

export function useFeatureHost(): FeatureHost {
  const host = useContext(NavigationContext);

  if (!host) throw new Error("Shared features require a navigation host");

  return host;
}
